import Button from 'components/Button/Button';
import useStateStore from 'services/store';
import './information-container.scss';
import { inforTab } from 'services/types';
import BodyMeasurement from './BodyMeasurement/BodyMeasurement';
import FinishedShirt from './FinishedShirt/FinishedShirt';
import SendSample from './SendSample/SendSample';

type inforTabVar = {
  id: inforTab;
  text: string;
  img: string;
};

const inforTabs: inforTabVar[] = [
  {
    id: 'body',
    text: 'Body measurement(inch)',
    img: 'images/configurator/body-msm.png',
  },
  {
    id: 'finished',
    text: 'Finished shirt measurement(inch)',
    img: 'images/configurator/finished-shirt-msm.png',
  },
  {
    id: 'sample',
    text: 'Send sample shirt',
    img: 'images/configurator/follow-previous.png',
  },
  // {
  //   id: 4,
  //   text: 'Follow Previous Order Measurement',
  //   img: 'images/configurator/send-sample.png',
  // },
];

const InformationContainer = () => {
  const {
    inforFlow,
    inforStep,
    inforFormState,
    changeInforFlow,
    changeInforStep,
    changeInforFormState,
    submitData,
  } = useStateStore();

  const handleChangeFlow = (id: inforTab) => {
    changeInforFlow(id);
    changeInforStep(1);
  };

  // const [inforTab, setInforTab] = useState(1);

  return (
    <div className={`information ${inforFormState ? 'active' : ''}`}>
      <div
        onClick={() => changeInforFormState(false)}
        className="overlay"
      ></div>
      <div className="infor-container">
        {inforStep > 0 && inforFlow !== 'sample' && (
          <div className="progress-container">
            <div className="progress">
              {inforStep + 1} / {inforFlow === 'body' ? '8' : '6'}
            </div>
            <div className="progress-bar">
              <div
                style={{
                  width:
                    inforFlow === 'body'
                      ? ((inforStep + 1) / 8) * 100 + '%'
                      : ((inforStep + 1) / 6) * 100 + '%',
                }}
                className="loaded"
              ></div>
            </div>
          </div>
        )}
        <div className="header">
          <span onClick={() => changeInforFormState(false)} className="cancel">
            <img src="images/cancel.svg" alt="" />
          </span>
        </div>
        <div className="body">
          {inforStep === 0 && inforFlow === '' && <BodyMeasurement />}
          {inforFlow === 'body' && <BodyMeasurement />}
          {inforFlow === 'finished' && <FinishedShirt />}
          {inforFlow === 'sample' && <SendSample />} 
        </div>
        {inforFlow === '' && inforStep === 0 && (
          <div className="tabs">
            <div className="tabs-container">
              <div className="tab-list">
                {inforTabs.map((tab) => {
                  return (
                    <div
                      key={tab.id}
                      onClick={() => handleChangeFlow(tab.id)}
                      // className={`tab ${inforTab === tab.id ? 'active' : ''}`}
                      className="tab"
                    >
                      <div className="img-container">
                        <img
                          content="img-tab"
                          src={tab.img}
                          className="img"
                          alt=""
                        />
                      </div>
                      <div className="text">{tab.text}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        {inforFlow !== '' && (
          <div className="infor-navigate">
            {inforStep > 0 && (
              <Button
                onClick={() => changeInforStep(inforStep - 1)}
                variant="teriary"
              >
                Back
              </Button>
            )}
            {((inforStep > 0 && inforStep < 7 && inforFlow === 'body') ||
              (inforStep > 0 && inforStep < 5 && inforFlow === 'finished') ||
              (inforStep > 0 && inforStep < 1 && inforFlow === 'sample')) && (
              <Button onClick={() => changeInforStep(inforStep + 1)}>
                Further
              </Button>
            )}
          </div>
        )}
        {((inforFlow === 'body' && inforStep === 7) ||
          (inforFlow === 'finished' && inforStep === 5) ||
          (inforFlow === 'sample' && inforStep === 1)) && (
          <div onClick={submitData} className="footer">
            <Button>ADD TO CART</Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InformationContainer;
 